import React, { useState } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog"
import { Button } from "../../../components/ui/button"
import { Badge } from "../../../components/ui/badge"
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card"
import { Separator } from "../../../components/ui/separator"
import { Copy, Edit, Trash, MoreVertical, Plus, Package2 } from "lucide-react"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../../components/ui/accordion"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs"
import { ScrollArea } from "../../../components/ui/scroll-area";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter, SheetTrigger } from "../../../components/ui/sheet"

// Sample data for demonstration
const sampleProductType = {
    id: "9c6c3410-801e-4f9e-b93d-c3a085a22429",
    code: "GEM",
    catalogName: "Gems",
    description: "GEM for testing",
    fields:
        '[{"id": "3967389c-ffad-45e8-8110-8a27468805e5", "name": "Gem Stones", "isActive": true, "fieldName": "GemStones", "dataFieldId": null, "displayName": "Gem Stones", "childDataField": [{"id": "9feb590b-e961-4ec3-a3bf-d65ff870d4e2", "isActive": true, "fieldName": "GemstoneCarat", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Carat", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "3c57ed8f-fb5e-412d-9792-67a94a7c75a9", "isActive": true, "fieldName": "GemstoneType", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Type", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "41bda8d5-8312-48a5-9149-7982bb0dfb68", "isActive": true, "fieldName": "GemstoneColor", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Color", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "2855a49d-32a0-4093-9e11-e108fdb1acb2", "isActive": true, "fieldName": "GemstoneClarity", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Clarity", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "83c9070f-51fa-4fd0-b070-f57fe820596b", "isActive": true, "fieldName": "GemstoneCut", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Cut", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "183ed5f2-482e-4f55-9ca1-e645545a3634", "isActive": true, "fieldName": "GemstoneOrigin", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Origin", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "26e3297a-e973-46c9-9fb4-68e9b2957b19", "isActive": true, "fieldName": "GemstoneTreatment", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Treatment", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "3d1730cd-d880-46b3-b586-a7f860f3b4fa", "isActive": true, "fieldName": "GemstoneShape", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Shape", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "c721aa19-3cdd-4163-b6c6-6e30b074231c", "isActive": true, "fieldName": "GemstoneCertification", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Gemstone Certification", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "1a99ef29-f82f-46fe-8618-08e28a424cf9", "isActive": true, "fieldName": "IsMainStone", "dataFieldId": "3967389c-ffad-45e8-8110-8a27468805e5", "displayName": "Main Stone", "childDataField": null, "backendFieldType": "Boolean", "frontEndFieldType": "checkbox"}], "backendFieldType": "Object", "frontEndFieldType": "List"}, {"id": "b7119bf6-8d12-4738-a306-2c8f7676747b", "name": "Supplier", "isActive": true, "fieldName": "Supplier", "dataFieldId": null, "displayName": "Supplier", "childDataField": [{"id": "7e35b98a-3ec1-4e44-acb2-ef091fd799d1", "isActive": true, "fieldName": "SupplierAddress", "dataFieldId": "b7119bf6-8d12-4738-a306-2c8f7676747b", "displayName": "Supplier Address", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "dc83df01-d958-4efa-8435-818cfa0194e4", "isActive": true, "fieldName": "SupplierName", "dataFieldId": "b7119bf6-8d12-4738-a306-2c8f7676747b", "displayName": "Supplier Name", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "f335781b-3fe4-47ba-b9e0-fd3bae025509", "isActive": true, "fieldName": "SupplierContact", "dataFieldId": "b7119bf6-8d12-4738-a306-2c8f7676747b", "displayName": "Supplier Contact", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "8c2d028d-703f-4fb8-9d13-c280c571d5b1", "isActive": true, "fieldName": "SupplierPhone", "dataFieldId": "b7119bf6-8d12-4738-a306-2c8f7676747b", "displayName": "Supplier Phone", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "d69b9843-8d46-4519-bc2c-e6584c05eca8", "isActive": true, "fieldName": "SupplierEmail", "dataFieldId": "b7119bf6-8d12-4738-a306-2c8f7676747b", "displayName": "Supplier Email", "childDataField": null, "backendFieldType": "String", "frontEndFieldType": "text"}, {"id": "dd08a3d5-8cbc-4ea6-b7b2-7c6876f49ea5", "isActive": true, "fieldName": "SupplierPrice", "dataFieldId": "b7119bf6-8d12-4738-a306-2c8f7676747b", "displayName": "Supplier Price", "childDataField": null, "backendFieldType": "Decimal", "frontEndFieldType": "number"}], "backendFieldType": "Object", "frontEndFieldType": "List"}]',
}

const getFieldTypeBadge = (type: string) => {
    switch (type) {
        case "String":
            return <Badge className="bg-blue-100 text-blue-800">Text</Badge>
        case "Decimal":
        case "Number":
            return <Badge className="bg-green-100 text-green-800">Number</Badge>
        case "Boolean":
            return <Badge className="bg-yellow-100 text-yellow-800">Boolean</Badge>
        case "Date":
            return <Badge className="bg-purple-100 text-purple-800">Date</Badge>
        case "Object":
            return <Badge className="bg-gray-100 text-gray-800">Object</Badge>
        default:
            return <Badge>{type}</Badge>
    }
}



const parseProductTypeFields = (fields: string | unknown) => {
    try {
        const parsed = typeof fields === "string" ? JSON.parse(fields) : fields;
        if (Array.isArray(parsed)) {
            return parsed.map((field) => ({
                id: field.id,
                displayName: field.displayName || field.fieldDisplayName || field.fieldName,
                fieldName: field.fieldName,
                frontEndFieldType: field.frontEndFieldType || field.masterMetaDataFieldType?.frontEndFieldType || field.masterMetaDataFieldType?.fieldType || "text",
                isRequiredField: field.isRequiredField,
                fieldDescription: field.fieldDescription,
                childDataField: field.childDataField,
            }));
        }
        if (parsed?.metaDataFields && Array.isArray(parsed.metaDataFields)) {
            return parsed.metaDataFields.map((field) => ({
                id: field.id,
                displayName: field.fieldDisplayName || field.fieldName,
                fieldName: field.fieldName,
                frontEndFieldType: field.masterMetaDataFieldType?.frontEndFieldType || field.masterMetaDataFieldType?.fieldType || "text",
                isRequiredField: field.isRequiredField,
                fieldDescription: field.fieldDescription,
                childDataField: null,
            }));
        }
        return [];
    } catch (e) {
        console.error("Error parsing fields", e);
        return [];
    }
};

const ProductTypeDetailsView = ({ productType, open, onOpenChange }) => {
    const [copied, setCopied] = useState(false)
    const [activeTab, setActiveTab] = useState("overview")

    if (!productType) return null

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    // Parse fields JSON
    const parsedFields = parseProductTypeFields(productType.fields);

    // Render field structure recursively
    const renderFieldStructure = (field, level = 0) => {
        const hasChildren = field.childDataField && field.childDataField.length > 0

        return (
            <div key={field.id} className={`pl-${level * 4} border-l-2 border-gray-200 ml-${level > 0 ? 4 : 0} mt-2`}>
                <div className="flex items-center gap-2 pl-2">
                    {hasChildren ? (
                        <Accordion type="single" collapsible className="w-full">
                            <AccordionItem value={field.id} className="border-none">
                                <AccordionTrigger className="py-1 hover:no-underline">
                                    <div className="flex items-center gap-2">
                                        <span className="font-medium">{field.displayName}</span>
                                        <Badge variant="outline" className="bg-purple-100 text-purple-800 border-purple-200">
                                            {field.frontEndFieldType}
                                        </Badge>
                                    </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                    {field.childDataField?.map((childField) => renderFieldStructure(childField, level + 1))}
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>
                    ) : (
                        <div className="flex items-center gap-2 py-1 pl-8">
                            <span className="font-medium">{field.displayName}</span>
                            {field.isRequiredField && (
                                <Badge variant="outline" className="bg-red-100 text-red-800 border-red-200">Required</Badge>
                            )}
                            <Badge variant="outline" className="bg-purple-100 text-purple-800 border-purple-200">
                                {field.frontEndFieldType}
                            </Badge>
                            {field.fieldDescription && (
                                <span className="text-xs text-gray-500">{field.fieldDescription}</span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    return (
        <Sheet open={open} onOpenChange={(event) => onOpenChange(null, event)}>
            <SheetContent side="right" className="w-full min-w-[600px] p-0 overflow-auto">
                {/* <SheetHeader className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 border-b detail-header">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <div className="bg-purple-100 p-2 rounded-lg">
                                <Package2 className="h-6 w-6 text-purple-600" />
                            </div>
                            <div>
                                <SheetTitle className="text-xl font-bold text-gray-900">{productType.catalogName} ({productType.code})</SheetTitle>
                                <p className="text-sm text-gray-600 mt-1">{productType.description}</p>
                            </div>
                        </div>
                    </div>

                    <Button variant="outline" onClick={() => onOpenChange(null, false)} className="close-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x h-4 w-4"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                    </Button>
                </SheetHeader> */}

                <SheetHeader className="p-6 border-b">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <div className="bg-purple-100 p-2 rounded-lg">
                                <Package2 className="h-6 w-6 text-purple-600" />
                            </div>
                            <div>
                                <SheetTitle className="text-xl font-bold">{productType.catalogName} ({productType.code})</SheetTitle>
                                <p className="text-sm text-gray-300 mt-1">{productType.description}</p>
                            </div>
                        </div>
                    </div>
                </SheetHeader>

                {/* <SheetHeader className="bg-black text-white p-6">
                    <div className="flex items-center space-x-4">
                        <div className="bg-white/20 rounded-full p-3">
                            <span className="font-bold text-xl">PT</span>
                        </div>
                        <div>
                            <SheetTitle className="text-2xl font-bold text-white">
                                {productType.catalogName} ({productType.code})
                            </SheetTitle>
                            <p className="text-sm opacity-80 mt-1">{productType.description}</p>
                        </div>
                        <Badge className="ml-auto bg-purple-300 text-purple-900">Product Type</Badge>
                    </div>
                </SheetHeader> */}


                <Tabs defaultValue="overview" className="w-full" onValueChange={setActiveTab}>
                    <div className="px-6 pt-6">
                        <TabsList className="grid w-full grid-cols-2">
                            <TabsTrigger value="overview">Overview</TabsTrigger>
                            <TabsTrigger value="fields">Fields Structure</TabsTrigger>
                        </TabsList>
                    </div>

                    <div className="p-6 overflow-y-auto">
                        <TabsContent value="overview" className="mt-0">
                            <Card>
                                <CardHeader>
                                    <CardTitle>Product Type Information</CardTitle>
                                </CardHeader>
                                <CardContent className="space-y-4">
                                    <div className="grid grid-cols-2 gap-4">
                                        {/* <div>
                                            <p className="text-sm text-gray-500">ID</p>
                                            <div className="flex items-center">
                                                <p className="font-mono text-sm truncate">{productType.id.substring(0, 12)}...</p>
                                                <Button
                                                    variant="ghost"
                                                    size="icon"
                                                    className="h-6 w-6 ml-1"
                                                    onClick={() => copyToClipboard(productType.id)}
                                                >
                                                    <Copy className="h-3 w-3" />
                                                </Button>
                                            </div>
                                        </div> */}
                                        <div>
                                            <p className="text-sm text-gray-500">Code</p>
                                            <p className="font-medium">{productType.code}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Name</p>
                                            <p className="font-medium">{productType.catalogName}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Description</p>
                                            <p className="font-medium">{productType.description}</p>
                                        </div>
                                    </div>

                                    <Separator />

                                    <div>
                                        <p className="text-sm text-gray-500 mb-2">Fields Summary</p>
                                        <div className="flex flex-wrap gap-2">
                                            {parsedFields.map((field) => (
                                                <Badge key={field.id} className="bg-purple-100 text-purple-800">
                                                    {field.displayName}
                                                </Badge>
                                            ))}
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </TabsContent>

                        <TabsContent value="fields" className="mt-0">
                            <Card>
                                <CardHeader>
                                    <CardTitle>Fields Structure</CardTitle>
                                </CardHeader>
                                <CardContent>
                                    <div className="space-y-4">{parsedFields.map((field) => renderFieldStructure(field))}</div>
                                </CardContent>
                            </Card>
                        </TabsContent>
                    </div>
                </Tabs>

                <SheetFooter>
                    {/* Footer Actions */}
                    <div className="absolute bottom-0 left-0 right-0 px-6 py-4 border-t border-border bg-card flex justify-end gap-3">
                        <Button
                            type="submit"
                            onClick={() => onOpenChange(null, false)}
                            className="bg-primary text-primary-foreground hover:bg-primary/90"
                        >
                            Close
                        </Button>
                    </div>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    )
}

export default ProductTypeDetailsView;
